module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "bb8-block"
  }, [_h('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.block.fields.url == ''),
      expression: "block.fields.url == ''"
    }],
    staticClass: "bb8-form-control",
    attrs: {
      "placeholder": "Paste a GitHub Gist url and press enter",
      "required": ""
    },
    domProps: {
      "value": _vm.block.fields.url
    },
    on: {
      "keydown": [function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        $event.preventDefault();
        _vm.loadGist($event)
      }, function($event) {
        if (_vm._k($event.keyCode, "delete", [8, 46])) { return; }
        _vm.removeBlock($event, true)
      }]
    }
  }), " ", _h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.block.fields.url != ''),
      expression: "block.fields.url != ''"
    }],
    staticClass: "bb8-block-gist-preview-wrapper"
  }, [_h('div', {
    staticClass: "bb8-block-gist-preview"
  }), " ", _h('a', {
    staticClass: "bb8-block-remove",
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        _vm.removeBlock()
      },
      "keypress": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.removeBlock()
      }
    }
  }, [_h('svg', {
    staticClass: "icon icon-remove"
  }, [_h('use', {
    attrs: {
      "xlink:href": "#icon-remove"
    }
  })])])]), " ", _vm._t("default")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39538eb8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/GistBlock.vue
// module id = 42
// module chunks = 0